const LIVE_STATUS_SET = new Set([
  'live',
  'inplay',
  'in_play',
  'in-progress',
  'in_progress',
  'playing',
  'halftime',
  'paused',
  'half_time',
  'ht',
  'between_periods',
  'between_sets',
  'break',
  'interval',
]);
const TERMINAL_STATUS_SET = new Set([
  'final',
  'completed',
  'ended',
  'end',
  'finished',
  'cancelled',
  'canceled',
  'abandoned',
  'settled',
  'closed',
]);

export const isSportsnewActiveLiveStatus = status => LIVE_STATUS_SET.has(
  String(status ?? '').trim().toLowerCase(),
);

/**
 * One shared visibility contract for Sportsnew live list consumers.
 *
 * The REST list can briefly retain a row while its mode/status transition is
 * being projected. Every consumer must make the same decision during that
 * window so the rendered cards and their navigation count cannot diverge.
 */
export const isSportsnewLiveFixtureRow = (fixture) => {
  if (!fixture) return false;
  const status = String(
    fixture.status ?? fixture.fixtureStatus ?? fixture.fixture_status ?? '',
  ).trim().toLowerCase();
  if (TERMINAL_STATUS_SET.has(status)) return false;
  const sourceMode = String(
    fixture.sourceMode ?? fixture.source_mode ?? '',
  ).trim().toLowerCase();
  if (sourceMode && sourceMode !== 'live') return false;
  if (sourceMode === 'live') return true;
  if (fixture.is_live === true || fixture.isLive === true || fixture.live === true) return true;
  return isSportsnewActiveLiveStatus(status);
};

export const isSportsnewFixtureVisibleForMode = (fixture, mode) => (
  String(mode ?? '').trim().toLowerCase() !== 'live'
  || isSportsnewLiveFixtureRow(fixture)
);

export default Object.freeze({
  isSportsnewFixtureVisibleForMode,
  isSportsnewLiveFixtureRow,
  isSportsnewActiveLiveStatus,
});
